.root {
	display: flex;
	min-width: 0;
	flex-wrap: wrap;
	justify-content: flex-end;
	gap: 6px;
}

.button {
	padding: 0;
	border: 0;
	background: transparent;
	cursor: pointer;
	transition: filter 140ms ease;
}

.button:hover {
	filter: brightness(1.08);
}

.button:focus-visible {
	outline: 3px solid var(--purple);
	outline-offset: 2px;
	box-shadow: none;
}

.tag {
	display: flex;
	min-height: 30px;
	align-items: center;
	gap: 5px;
	padding: 0 7px;
	text-shadow: 0 1px 1px rgba(37, 33, 52, 0.36);
}

.icon {
	width: 15px;
	height: 15px;
}

.root b {
	color: inherit;
	font-family: var(--font-mono);
	font-size: 13px;
}

@media (max-width: 620px) {
	.tag {
		min-height: 26px;
		flex: 0 0 auto;
	}
}
